<template>
  <div>
    <job-content-table title="企業情報">
      <job-content-table-outline
        title="業種"
        :value="companySupplementInfo.businessName"
      />
      <job-content-table-outline
        title="正式社名"
        :value="companySupplementInfo.formalName"
      >
        <br>
        <span class="pega-company-preview-name-caution-text">
          ※支店名、事業部名、グループ名等の入力不可。
        </span>
        <span
          v-if="companySupplementInfo.isVisibleInGoogle"
          data-test="formal-company-name-cation"
          class="pega-company-preview-name-caution-text"
        >
          ※提携サイト掲載時にこちらの社名が使用されます。
        </span>
      </job-content-table-outline>
      <job-content-table-outline
        title="表示用社名"
        :value="companySupplementInfo.name"
      >
        <template v-if="!companySupplementInfo.isVisibleInGoogle">
          <br>
          <span
            data-test="company-name-cation"
            class="pega-company-preview-name-caution-text"
          >
            ※提携サイト掲載時にこちらの社名が使用されます。
          </span>
        </template>
      </job-content-table-outline>
      <job-content-table-outline
        title="表示用社名(カナ)"
        :value="companySupplementInfo.nameKana"
      />
      <job-content-table-outline-sub
        title="関連キーワード"
        :contents="keywords"
      />
      <job-content-table-outline-sub
        title="関連リンク"
        :contents="relationLinks"
      />
    </job-content-table>

    <job-content-table title="応募フォーム">
      <job-content-table-outline
        v-for="(question, i) in questions"
        :key="i"
        :title="`独自質問項目名[${i + 1}]`"
        :value="question"
      />
    </job-content-table>
  </div>
</template>

<script>
import JobContentTable from '@/components/atoms/JobContentTable'
import JobContentTableOutline from '@/components/atoms/JobContentTableOutline'
import JobContentTableOutlineSub from '@/components/molecules/JobContentTableOutlineSub'
export default {
  components: {
    JobContentTable,
    JobContentTableOutline,
    JobContentTableOutlineSub
  },
  props: {
    companySupplementInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    maxLength () {
      return {
        keyWord: 5,
        relationLink: 3,
        question: 3
      }
    },
    keywords () {
      // 共通コンポーネントを利用できる形式に整形
      const fullKeywords = this.fillArray(this.companySupplementInfo.keywords, this.maxLength.keyWord)
      return fullKeywords.map((keyword, index) => {
        return {
          parentName: `キーワード[${index + 1}]`,
          nameList: keyword ? [keyword] : []
        }
      })
    },
    relationLinks () {
      // 共通コンポーネントを利用できる形式に整形
      const fullRelationLinks = this.fillArray(this.companySupplementInfo.relationLinks, this.maxLength.relationLink)
      return fullRelationLinks.reduce((acc, relationLink, index) => {
        const name = {
          parentName: `関連リンク［${index + 1}］名`,
          nameList: relationLink?.key ? [relationLink.key] : []
        }
        const url = {
          parentName: `関連リンク［${index + 1}］URL`,
          nameList: relationLink?.value ? [relationLink.value] : []
        }
        acc.push(name, url)
        return acc
      }, [])
    },
    questions () {
      return this.fillArray(this.companySupplementInfo.questions, this.maxLength.question)
    }
  },
  methods: {
    fillArray (array, maxLength, value = null) {
      return array.concat(Array(maxLength - array.length).fill(value))
    }
  }
}
</script>
